// import React from 'react'

// const ForgotPasswordFlow = () => {
//   return (
//     <div>ForgotPasswordFlow</div>
//   )
// }

// export default ForgotPasswordFlow

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import axios from 'axios';
import { Card, Grid, Typography, Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import signupwallpaper from '../../assets/signupwallpaper.svg';
import msglogo from '../../assets/Messages.svg';
import backArrow from '../../assets/arrow-left.svg';
import {
  InputField,
  CheckBoxK,
  ButtonK,
  TestimonialCarousel,
  MainCard,
} from '@datascient/datascient-ui-library';

import { testimonials } from './Testimonials';
import CreateAccountFooter from './CreateAccountFooter';

import TermsofUseDialog from './TermsofUseDialog';

import { decryptObject, encryptObject } from '../api/Auth';
import { useNavigate } from 'react-router-dom';
import { environment } from '../../environments/environment';

const ForgotPasswordFlow = () => {
  const [signupFlag, setsignupFlag] = useState(false);
  const [email, setEmail] = useState('');


  const [termsofUse, setTermsofUse] = useState(false);
  const [loading, setLoading] = useState(false);
  var navigate=useNavigate();
  useEffect(() => {}, [loading]);
  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

 

  const handleSubmit = async (e) => {
    e.preventDefault();
    getRegistration();
    setsignupFlag(true);
  };

  const handleClick1 = () => { navigate("/signup");};

  const handleBackClick = () => {
    setsignupFlag(false);
  };

  useEffect(() => {}, [signupFlag]);

  const getRegistration = async () => {
    setLoading(true);
    try {
      let data = { admin_email: email };

      let encryptedData = encryptObject(data);

      const payload = encryptedData;
      const res = await axios.post(
        `${environment.apiUrl}/auth/initiatePasswordReset`,
        payload
      );
      
      setsignupFlag(!signupFlag);
      setLoading(false);
    } catch (error) {
      console.log('error', error);
      setLoading(false);
    }
  };

  return (
    <Grid
      container
      style={{ margin: '0px', padding: '0px', height: '100% !important' }}
    >
      <Grid
        item
        xs={3}
        style={{
          backgroundImage: `url(${signupwallpaper})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '100vh',
        }}
      >
        <Box
          style={{
            position: 'relative',
            top: '80%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '10px',
            backgroundColor: 'transparent',
          }}
        >
          <TestimonialCarousel testimonials={testimonials} />
        </Box>
      </Grid>
      <Grid
        item
        xs={9}
        style={{ backgroundColor: '#FFF', height: '100% !important' }}
      >
        {signupFlag === false && (
          <Card
            style={{
              marginLeft: '25%',
              marginRight: '25%',
              marginTop: '10%',
              borderRadius: '20px',
              boxShadow: 'none',
            }}
          >
            <Box
              style={{
                display: 'flex',
                flexDirection: 'row',
                position: 'absolute',
                top: '10px',
                right: '40px',
                margin: '10px',
              }}
            >
              <Typography
                style={{
                  color: '#131F32',
                  fontWeight: '500',
                  fontSize: '14px',
                  marginTop: '15px',
                  marginRight: '10px',
                }}
              >
                Don’t have an account?
              </Typography>

              <ButtonK
                text="Sign Up"
                color="#159DFF"
                backgroundColor="#FFF"
                sx={{ height: '35px', width: '85px' }}
                varient={'outlined'}
                handleClick={handleClick1}
              />
            </Box>

            <Typography
              variant="h4"
              style={{
                fontSize: '32px',
                fontWeight: '600',
                textAlign: 'left',
                color: '#131F32',
                // margin: '15px',
                marginLeft: '50px',
              }}
            >
              Forgot Password
            </Typography>
            <Box style={{ padding: '25px' }}>
              <InputField
                question={'Email'}
                label={'Enter your email'}
                type={'email'}
                onChange={handleChangeEmail}
                required={true}
              />
           
            </Box>

            <ButtonK
              text="Send Reset Link"
              color="#131F32"
              backgroundColor="#FFD600"
              varient="filled"
              sx={{ margin: '0 auto', display: 'block' }}
              handleClick={handleSubmit}
            />
          </Card>
        )}
        {signupFlag === true && (
          <>
            <Box
              style={{
                position: 'relative',
                left: '10px',
                width: '50px',
                marginTop: '10px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <img style={{ marginTop: '10px' }} src={backArrow} alt="." />
              <ButtonK
                text="Back"
                color="#159DFF"
                backgroundColor="#FFF"
                varient="standard"
                handleClick={handleBackClick}
              />
            </Box>

            <Box
              style={{
                width: '37%',
                textAlign: 'center',
                margin: 'auto',
                marginTop: '120px',
                // marginBottom: '190px',
              }}
            >
              <MainCard
                maintext="Check Your Email"
                secondaryText="We have a sent verification link to your registered mail. Don’t forget to check the spam folder."
                thirdText="Didn’t receive the email? "
                logo={msglogo}
                buttonText="Send Again"
                buttonColor="#159DFF"
                buttonbg="#FFF"
                buttonVarient="standard"
                handleClick={() => {
                  alert('Button Clicked!');
                }}
              />
            </Box>
          </>
        )}
        <CreateAccountFooter />
      </Grid>
      <TermsofUseDialog
        open={termsofUse}
        handleClose={() => {
          setTermsofUse(!termsofUse);
        }}
      />
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '9999',
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
            }}
          >
            <CircularProgress
              style={{
                width: '100%',
                height: '100%',
                color:'#438BF5',
              }}
              thickness={8}
            />
          </div>
        </div>
      )}
    </Grid>
  );
};

export default ForgotPasswordFlow;
